module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/catasto_pic.97c4d997.png";